import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button, FormControl } from "@/comn/components"; // 화면 구성 컴포넌트
import {
    useForm,
    useAuth,
    useFetch,
    useResource,
    useGrid,
    useModal,
    useStore,
    useToast,
    usePopup,
    usePage,
} from "@/comn/hooks"; // hook
import {
    BASE,
    URLS,
    APIS,
    SF_BTCH_SCHD_FORM,
    SG_BTCH_SCHD_PRMT_LIST,
} from "@/tz/go/egaz/osci/ptl/btch/schd/services/OsciBtchSchdMgmtService";

/*
 * Manage schedules details
 * !== 스케줄관리 상세 ==!
 */
export const OSCI0112008Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const { btchSchdId } = useParams();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Manage schedules Form !== 스케줄관리 Form ==!
        btchInfoForm: useForm({
            defaultSchema: SF_BTCH_SCHD_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        btchSchdPrmtList: useGrid({
            defaultSchema: SG_BTCH_SCHD_PRMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getBtchSchdInfo: useFetch({
            api: () => APIS.getBtchSchdInfo(btchSchdId),
            onSuccess: (data: any) => {
                const schdInfo = data.schdInfo.content;
                const schdPrmtList = schdInfo.schdPrmtList;

                form.btchInfoForm.setValues(schdInfo);

                // Setting batch parameter list !== 스케줄 파라미터 목록 세팅 ==!
                grid.btchSchdPrmtList.setData(comnUtils.getGridData(schdPrmtList));
            },
            onError: (error) => {
                if (error.response.status === 400) {
                    const { errorMessage } = error.response.data;

                    modal.openModal({
                        content: errorMessage.content,
                        onConfirm: () => {
                            navigate(URLS.osci0112005q);
                        },
                        close: false,
                    });

                    return;
                }

                toast.showToast({ type: "error", content: "msg.osc.00035" }); // An error occurred. !== 에러가 발생했습니다! ==!
            },
        }),

        deleteBtchSchdInfo: useFetch({
            api: (info: any) => APIS.deleteBtchSchdInfo(info),
            onSuccess: () => {
                modal.openModal({ content: "msg.osc.00071" }); // Successfully removed. !== 정상적으로 삭제되었습니다. ==!
                navigate(URLS.osci0112005q);
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00040" }), // Failed to remove. !== 삭제가 실패하였습니다. ==!
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        onEditBtnClick: () => {
            navigate(`${URLS.osci0112007s}/${btchSchdId}`);
        },

        onDeleteBtnClick: () => {
            modal.openModal({
                content: "msg.osc.00062", // Confirm remove? !== 삭제하시겠습니까? ==!
                onConfirm: () => fetch.deleteBtchSchdInfo.fetch(form.btchInfoForm.getValue("btchSchdId")),
            });
        },
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {};

    /*
     * Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getBtchSchdInfo.fetch();

        form.btchInfoForm.setEditable(false);

        grid.btchSchdPrmtList.setOption("edit", false);
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.btchInfoForm.schema.btchId} controlSize={10} required={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.btchInfoForm.schema.btchNm} controlSize={10} required={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.btchInfoForm.schema.btchSchdId} controlSize={10} required={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.btchInfoForm.schema.btchSchdNm} controlSize={10} required={false} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.btchInfoForm.schema.btchSchdCnxsValue}
                                controlSize={10}
                                type="text"
                                required={false}
                            />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>

            {/* <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={"T_SCHD_PRMT_LIST"} titleSize={2}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Grid {...grid.btchSchdPrmtList.grid} />
                    </Group.Section>
                </Group.Body>
            </Group> */}

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0112005q);
                        }}
                    />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"edit"} onClick={handler.onEditBtnClick} />
                    <Layout.Button role={"delete"} onClick={handler.onDeleteBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
